import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, CifraCargando, Group } from "@/components/ui";

export function CatalogosSatHeader({
  total,
  totalUtilizables,
  modoCrear,
  onIniciarCrear,
}: {
  /** undefined en la primera carga (sin caché) · se pinta una barra en vez de «0». */
  total: number | undefined;
  totalUtilizables: number | undefined;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Catálogo SAT"
      description={
        <>
          Claves producto/servicio del SAT · <CifraCargando valor={total} /> registros (<CifraCargando valor={totalUtilizables} /> vigentes hoy).
          Se mantiene al día con el catálogo oficial del SAT; aquí también puedes dar de alta una clave a mano o corregir su texto descriptivo.
        </>
      }
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva clave
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
